export const ours = '59155432-d78f-4844-8ecb-90d40725be94';
export const prod = '1459d56c-9a37-4963-aa10-7ee47a7614b6';
